import React from 'react';
import { useWriterEnabled } from '@/hooks/useWriterEnabled';

interface WriterGateProps {
  children: React.ReactNode;
  /** Optional fallback while the admin check is in flight. Defaults to null. */
  fallback?: React.ReactNode;
}

/**
 * Renders `children` only when the PaperVerse Writer feature flag is on for the
 * current user. During the admin-only beta that means only admins see the
 * wrapped UI. Non-admins get `null` — no flicker, no leaked labels.
 */
const WriterGate: React.FC<WriterGateProps> = ({ children, fallback = null }) => {
  const { enabled, loading } = useWriterEnabled();
  if (loading) return <>{fallback}</>;
  if (!enabled) return null;
  return <>{children}</>;
};

export default WriterGate;
